import { render } from "./ResourcesIndex.vue?vue&type=template&id=0cd486f4&scoped=true"
import script from "./ResourcesIndex.vue?vue&type=script&lang=js"
export * from "./ResourcesIndex.vue?vue&type=script&lang=js"

import "./ResourcesIndex.vue?vue&type=style&index=0&id=0cd486f4&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd486f4"]])

export default __exports__